/**
 * API address for Store Admin requests, from REACT_APP_APIURL
 * (e.g. https://api.mytamilkart.com/api/), set at build time.
 *
 * There is no fallback host: a missing value is reported once at load, and
 * apiEndpoint() throws, so a misconfigured build fails with a clear error
 * instead of silently sending requests to the panel's own origin.
 */

export const API_URL = process.env.REACT_APP_APIURL || '';

export const MISSING_API_URL_MESSAGE =
  '[CONFIG] REACT_APP_APIURL is not set. Set it in .env (local) or the build environment, '
  + 'e.g. REACT_APP_APIURL=https://api.mytamilkart.com/api/';

if (!API_URL) {
  // eslint-disable-next-line no-console
  console.error(MISSING_API_URL_MESSAGE);
}

/**
 * Joins the API base and a path with exactly one slash, whether or not
 * REACT_APP_APIURL ends with "/" and the path starts with "/".
 * @param {string} path - e.g. "digital/upload" or "/digital/upload"
 * @param {string} [base] - defaults to REACT_APP_APIURL
 * @returns {string} e.g. "https://api.mytamilkart.com/api/digital/upload"
 * @throws {Error} when the base is not set
 */
export function apiEndpoint(path, base = API_URL) {
  if (!base) {
    throw new Error(MISSING_API_URL_MESSAGE);
  }
  return `${String(base).replace(/\/+$/, '')}/${String(path).replace(/^\/+/, '')}`;
}
